import React from 'react';
import '../../styles/eneos.css';

const CookiePolicy = () => {
  return (
    <div className="eneos-theme">
      <div className="eneos-container">
        <h1>Cookie Policy</h1>
        <p className="page-info">Last updated: {new Date().toLocaleDateString()}</p>

        <div className="info-box">
          <strong>About Cookies:</strong> This Cookie Policy explains how SoftLaabs uses cookies and similar technologies.
        </div>

        <h2>1. What Are Cookies?</h2>
        <p>
          Cookies are small text files that are placed on your device when you visit a website. They are widely used to make websites work more efficiently and provide information to website owners.
        </p>

        <h2>2. Types of Cookies We Use</h2>
        
        <h3>2.1 Essential Cookies</h3>
        <p>
          These cookies are necessary for the website to function properly. They enable basic functions like page navigation and access to secure areas.
        </p>
        <table>
          <thead>
            <tr>
              <th>Cookie Name</th>
              <th>Purpose</th>
              <th>Duration</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>session_id</td>
              <td>Maintains user session</td>
              <td>Session</td>
            </tr>
            <tr>
              <td>cookie_consent</td>
              <td>Stores cookie preferences</td>
              <td>1 year</td>
            </tr>
          </tbody>
        </table>

        <h3>2.2 Analytics Cookies</h3>
        <p>
          These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously.
        </p>

        <table>
          <thead>
            <tr>
              <th>Cookie Name</th>
              <th>Purpose</th>
              <th>Duration</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>_ga</td>
              <td>Google Analytics - distinguishes users</td>
              <td>2 years</td>
            </tr>
            <tr>
              <td>_gid</td>
              <td>Google Analytics - distinguishes users</td>
              <td>24 hours</td>
            </tr>
          </tbody>
        </table>

        <h3>2.3 Functional Cookies</h3>
        <p>
          These cookies enable enhanced functionality and personalization, such as remembering your preferences.
        </p>

        <h3>2.4 Marketing Cookies</h3>
        <p>
          These cookies track your online activity to help advertisers deliver more relevant advertising or to limit how many times you see an ad.
        </p>

        <h2>3. How We Use Cookies</h2>
        <p>We use cookies to:</p>
        <ul>
          <li>Keep you signed in to your account</li>
          <li>Remember your preferences and settings</li>
          <li>Understand how you use our website</li>
          <li>Improve our website performance</li>
          <li>Provide personalized content and recommendations</li>
          <li>Measure the effectiveness of our marketing campaigns</li>
        </ul>

        <h2>4. Third-Party Cookies</h2>
        <p>
          Some cookies are placed by third-party services that appear on our pages. We do not control these cookies. Third parties include:
        </p>
        <ul>
          <li><strong>Google Analytics:</strong> Website analytics and reporting</li>
          <li><strong>Social Media Platforms:</strong> Social sharing buttons and widgets</li>
          <li><strong>Payment Processors:</strong> Secure payment processing</li>
        </ul>

        <h2>5. Managing Cookies</h2>
        <p>
          You can control and manage cookies in various ways:
        </p>

        <h3>5.1 Browser Settings</h3>
        <p>
          Most browsers allow you to refuse or accept cookies. You can usually find these settings in the "Options" or "Preferences" menu of your browser.
        </p>
        <ul>
          <li><strong>Chrome:</strong> Settings → Privacy and security → Cookies</li>
          <li><strong>Firefox:</strong> Options → Privacy & Security → Cookies</li>
          <li><strong>Safari:</strong> Preferences → Privacy → Cookies</li>
          <li><strong>Edge:</strong> Settings → Cookies and site permissions</li>
        </ul>

        <h3>5.2 Cookie Consent Tool</h3>
        <p>
          When you first visit our website, you'll see a cookie consent banner. You can manage your preferences through this tool.
        </p>

        <div className="info-box warning">
          <strong>Note:</strong> Blocking or deleting cookies may impact your experience on our website and limit certain features.
        </div>

        <h2>6. Do Not Track Signals</h2>
        <p>
          Some browsers include a "Do Not Track" (DNT) feature. Our website does not currently respond to DNT signals, as there is no industry standard for how to interpret them.
        </p>

        <h2>7. Updates to This Cookie Policy</h2>
        <p>
          We may update this Cookie Policy from time to time to reflect changes in technology, legislation, or our business practices. We will notify you of any significant changes by posting the updated policy on our website.
        </p>

        <h2>8. Contact Us</h2>
        <p>
          If you have questions about our use of cookies, please contact us:
        </p>
        <div className="info-box">
          <strong>Email:</strong> <a href="mailto:softlaabs@softlaabs.org">softlaabs@softlaabs.org</a><br />
          <strong>Phone:</strong> +254 792560128
        </div>

        <hr />

        <h2>Cookie Categories Explained</h2>
        
        <h3>Strictly Necessary Cookies</h3>
        <p>
          These cookies are essential for you to browse the website and use its features. Without these cookies, services you have asked for cannot be provided.
        </p>

        <h3>Performance Cookies</h3>
        <p>
          These cookies collect information about how you use our website, such as which pages you visit most often. This data helps us optimize our website.
        </p>

        <h3>Functionality Cookies</h3>
        <p>
          These cookies allow our website to remember choices you make and provide enhanced features and personalized content.
        </p>

        <h3>Targeting/Advertising Cookies</h3>
        <p>
          These cookies are used to deliver advertisements more relevant to you and your interests. They also limit the number of times you see an advertisement.
        </p>

        <div style={{ marginTop: '2em' }}>
          <button className="eneos-btn">Manage Cookie Preferences</button>
          {' '}
          <button className="eneos-btn secondary">Download PDF</button>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
